import { Routes } from '@angular/router';

import { authRoutes } from '@shared/route/auth.route';
import { dashboardRoutes } from '@shared/route/dashboard.route';
import { ROUTE_PATH } from '@shared/enum/common.enum';

export const routes: Routes = [
    ...authRoutes,
    ...dashboardRoutes,

    {
        path: ROUTE_PATH.LOGIN,
        loadComponent: () =>
            import('@components/auth/login/login.component').then(
                (m) => m.LoginComponent
            ),
    },
    { path: '**', redirectTo: ROUTE_PATH.LOGIN },
];
